import { ENVMAPPING } from "./helper";

const envConfig = ENVMAPPING(globalThis.location.origin);

export const SSO_CLIENT_ID = envConfig.azure_app_id;
export const SSO_TENANT_URL = `https://login.microsoftonline.com/${envConfig.azure_client_id}`;
export const REDIRECT_URL = globalThis.location.origin;

export const ENCLAVE_PLATFORM_TITLE = "Enclave Platform";
export const TDSP_PORTAL_LABEL = "TDSP Portal";
export const TDSP_PORTAL_URL = envConfig.portalSwitchUrl || "";

export const FOOTER_TEXTS = {
  footerLeft: "TDSP Enclave",
  footerRight: "COPYRIGHT © {copyRightYear} | All Rights Reserved",
};
